module.exports = __webpack_public_path__ + "img/sleeve flounce length.ca3b5a27.png";